import React from 'react';
import * as starRatingStyles from '../star-rating/star-rating.style';
import * as styles from './star.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export function Star(_ref) {
  var fillBackground = _ref.fillBackground,
    fillStar = _ref.fillStar,
    _ref$percentage = _ref.percentage,
    percentage = _ref$percentage === void 0 ? 100 : _ref$percentage,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    _ref$strokeColor = _ref.strokeColor,
    strokeColor = _ref$strokeColor === void 0 ? starRatingStyles.FILL_COLOR : _ref$strokeColor,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 4 : _ref$strokeWidth;
  var getStarType = () => {
    var filledPercentage = percentage > 0 && percentage < 1 ? percentage * 100 : percentage;
    return Math.round(filledPercentage / 25);
  };
  var getFilledStarPolygonPoints = type => {
    switch (type) {
      case 1:
        return '22,57.2 22,22 0,25 0,25 15.9,40.5 12.1,62.3';
      case 2:
        return '22.1,21.9 0,25 0,25 15.9,40.5 12.1,62.3 32,52 32,1.7';
      case 3:
        return '41.9,21.9 32,1.7 22.1,21.9 0,25 0,25.1 15.9,40.5 12.1,62.3 32,52 41.9,57.2';
      default:
        return '';
    }
  };
  var starType = getStarType();
  var polygonPoints = getFilledStarPolygonPoints(starType);
  return ___EmotionJSX("span", {
    css: styles.star(size)
  }, ___EmotionJSX("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64"
  }, ___EmotionJSX("title", null, "Star"), ___EmotionJSX("polygon", {
    css: styles.polygonStyled(starType, fillStar, fillBackground, strokeColor, strokeWidth),
    points: "64,25 41.9,21.9 32,1.7 22.1,21.9 0,25 15.9,40.5 12.1,62.3 32,52 51.9,62.3 48.1,40.5"
  }), polygonPoints.length && ___EmotionJSX("polygon", {
    points: polygonPoints,
    style: {
      fill: fillStar
    }
  })));
}